<template>

<div class="product-title">{{ product.title }}</div>

</template>

<script>
export default {
	name: 'product-title',
	props: ['product']
}
</script>
